// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signin-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.signin-container .signin-logo {
  width: 130px;
  position: absolute;
  top: 50px;
  left: 50px;
}
.signin-container .email-row {
  font-size: 14px;
  color: #365A64;
}
.signin-container .signin-box-wrapper {
  padding: 20px;
}
.signin-container .signin-box-wrapper .signin-box {
  background-color: #fff;
  border-radius: 10px;
  width: 490px;
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.signin-container .signin-box-wrapper .signin-box .signin-description {
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  color: #365A64;
  width: 330px;
  padding: 20px 0;
}
.signin-container .signin-box-wrapper .signin-box .signin-input {
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  padding: 14px;
  margin-bottom: 14px;
  width: 300px;
}
.signin-container .signin-box-wrapper .signin-box .signin-error {
  color: red;
  padding: 5px 0 20px 0;
  font-size: 13px;
}
.signin-container .signin-box-wrapper .signin-box .signin-button {
  cursor: pointer;
}
.signin-container .signin-box-wrapper .signin-box .signin-forgot-password {
  color: #03A9F4;
  width: 330px;
  font-size: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/SignInPage/SignInPage.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;AAEC;EACC,eAAA;EACA,cAAA;AAAF;AAGC;EACC,aAAA;AADF;AAGE;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AADH;AAGG;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AADJ;AAIG;EACC,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAKG;EACC,UAAA;EACA,qBAAA;EACA,eAAA;AAHJ;AAMG;EACC,eAAA;AAJJ;AAOG;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AALJ","sourcesContent":[".signin-container {\n\tdisplay: flex;\n\theight: 100vh;\n\twidth: 100vw;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.signin-logo {\n\t\twidth: 130px;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tleft: 50px;\n\t}\n\n\t.email-row {\n\t\tfont-size: 14px;\n\t\tcolor: #365A64;\n\t}\n\n\t.signin-box-wrapper {\n\t\tpadding: 20px;\n\n\t\t.signin-box {\n\t\t\tbackground-color: #fff;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 490px;\n\t\t\tdisplay: flex;\n\t\t\tpadding: 20px 0;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-around;\n\t\t\talign-items: center;\n\n\t\t\t.signin-description {\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 17px;\n\t\t\t\tcolor: #365A64;\n\t\t\t\twidth: 330px;\n\t\t\t\tpadding: 20px 0;\n\t\t\t}\n\n\t\t\t.signin-input {\n\t\t\t\tborder: 1px solid #D3E1ED;\n\t\t\t\tborder-radius: 5px;\n\t\t\t\tpadding: 14px;\n\t\t\t\tmargin-bottom: 14px;\n\t\t\t\twidth: 300px;\n\t\t\t}\n\n\t\t\t.signin-error {\n\t\t\t\tcolor: red;\n\t\t\t\tpadding: 5px 0 20px 0;\n\t\t\t\tfont-size: 13px;\n\t\t\t}\n\n\t\t\t.signin-button {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.signin-forgot-password {\n\t\t\t\tcolor: #03A9F4;\n\t\t\t\twidth: 330px;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tuser-select: none;\n\t\t\t}\n\t\t}\n\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
